import useRouter from '@/hooks/useRouter'

const useQueryFilters = (filterTypes: any) => {
  const { router, route } = useRouter()

  function setQueryFilters(params: any): void {
    router.replace({ query: params })
  }

  const getQueryFilters = function (): object {
    const params = route.value.query

    Object.keys(params).forEach(function (key, _) {
      params[key] = toType(params[key], filterTypes[key])
    })

    return params
  }

  const resetQueryFilters = function () {
    router.replace({ query: {} })
  }

  const toType = function (param: any, type: any) {
    switch (type) {
      case 'string':
        return String(param)
      case 'int':
        return parseInt(param)
      case 'array-int':
        return [param].flat().map((el) => parseInt(el))
      case 'array-str':
        return [param].flat().map((el) => String(el))
      case 'array-bool':
        return [param]
          .flat()
          .map((el) => (typeof el === 'boolean' ? el : el === 'true'))
      default:
        return param
    }
  }

  return { setQueryFilters, getQueryFilters, resetQueryFilters }
}

export default useQueryFilters
